<template><service-intro v-if="presentation.renewed" /><legacy-service v-else /></template>
<script>
import LegacyService from '../pages/service.vue';
import ServiceIntro from './ServiceIntro.vue';
import { presentation } from './presentation';
export default { components: { LegacyService, ServiceIntro }, data: () => ({ presentation }) };
</script>
